import _ from 'lodash';
import clsx from 'clsx';

import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  passcode: string;
  maxLength: number;
  error?: boolean;
}

export default class PasscodeDigits extends PureBaseComponent<Props> {
  render() {
    const { passcode, maxLength, error } = this.props;
    return (
      <div className="PasscodeDigits FSHide">
        {_.times(maxLength, (i) => (
          <div
            key={i}
            className={clsx('PasscodeDigits-digit', {
              'PasscodeDigits-digit--active': i <= passcode.length,
              'PasscodeDigits-digit--error': error,
            })}
          >
            <span>{passcode[i]}</span>
          </div>
        ))}
      </div>
    );
  }
}
